import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { IApplicationState, AppActionCreators, IArrayResponse } from '@nkr/store/index';
import { IInvoiceSummary, ActionsAdminInvoice } from '@nkr/store/billing/actions-admin-invoice';
import GridInvoiceCollections from './grid-collections';
import DateTimePicker from '@nkr/components/date-time-picker';
import { FilterWrapper } from '../transplant-invoices/styles';
import { FormControl, Button, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps extends RouteComponentProps<{}> { }

interface IStateProps {

}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCollections: (isPaid: boolean, organType: OrganType, paidStartDate: string, paidEndDate: string) => Promise<IArrayResponse<IInvoiceSummary>>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    isPaid: boolean,
    organTypes: OrganType[],
    list: IInvoiceSummary[],
    paidStartDate: moment.Moment,
    paidEndDate: moment.Moment,
    centerId: number,
    gridApi: GridApi
}

class Collections extends React.Component<TProps, IState> {
    readonly state: IState = {
        isPaid: false,
        organTypes: [OrganType.Kidney, OrganType.Liver],
        list: [],
        paidStartDate: moment().subtract(1, 'years'),
        paidEndDate: moment(),
        gridApi: null,
        centerId: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let isPaid = this.state.isPaid;
        let organTypes = this.state.organTypes;
        let paidStartDate = this.state.paidStartDate;
        let paidEndDate = this.state.paidEndDate;
        let organType = organTypes.length == 2 ? null : organTypes[0];

        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.getCollections(isPaid, organType, paidStartDate.format("YYYY-MM-DD"), paidEndDate.format("YYYY-MM-DD"))
                .then((response: IArrayResponse<IInvoiceSummary>) => {
                    if (response.data.success) {
                        this.setState({
                            isPaid: isPaid,
                            organTypes: organTypes,
                            list: response.data.results
                        });
                    }
                })
                .finally(() => { this.props.hideLoading(); });
        });
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    updateSearch = (e) => {
        this.getData();
    }

    changePage = (e) => {
        var isPaid = e.target.value === 'true';
        this.setState({ isPaid: isPaid }, () => this.getData());
    }

    changeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];
        if (safeValues.length === 0) return;
        this.setState({ organTypes: safeValues }, () => this.getData());
    }

    handleStartDateUpdate = (property: string, value: moment.Moment) => {
        this.setState({ paidStartDate: value });
    }

    handleEndDateUpdate = (property: string, value: moment.Moment) => {
        this.setState({ paidEndDate: value });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        let filePrefix = this.state.centerId > 0 ? this.state.list.filter(x => x.centerId == this.state.centerId).map(x => x.centerAlias)[0].toLowerCase() : 'allcenters';

        let params: CsvExportParams = {
            columnGroups: true,
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();
                if (colDef.field == 'organType')
                    return params.value == 0 ? 'Kidney' : params.value == 1 ? 'Liver' : params.value;

                return params.value;
            },
            fileName: filePrefix + '-invoice-collections.csv',
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const centerList = _.sortBy(_.uniqBy(this.state.list.map(x => ({ id: x.centerId, alias: x.centerAlias })), item => item.id), item => item.alias);
        const data = this.state.centerId > 0 ? this.state.list.filter(x => x.centerId == this.state.centerId) : this.state.list;
        const organValue = this.state.organTypes.length == 2 ? -1 : this.state.organTypes[0];

        return (
            <>
                <FilterWrapper>
                    <div className="row">
                        <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 14, flexWrap: 'wrap', gap: 10 }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span>Center:</span>
                                    <FormControl componentClass='select' value={this.state.centerId} onChange={this.handleCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                                <span style={{ fontWeight: 500, marginLeft: 25 }}>Invoice Collections:</span>
                                <div className="btn-group" data-toggle="buttons">
                                    <button type='button' className={"btn " + (this.state.isPaid == false ? 'btn-primary active' : 'btn-default')} value='false' onClick={this.changePage.bind(this)}>Open</button>
                                    <button type='button' className={"btn " + (this.state.isPaid == true ? 'btn-primary active' : 'btn-default')} value='true' onClick={this.changePage.bind(this)}>Paid</button>
                                </div>
                                <span style={{ fontWeight: 500, marginLeft: 25 }}>Organ:</span>
                                <div className="btn-group" data-toggle="buttons">
                                    <ToggleButtonGroup type='radio' name='organs' value={organValue}>
                                        <ToggleButton value={-1} onChange={() => this.changeOrganType([OrganType.Kidney, OrganType.Liver])}
                                            className={this.state.organTypes.length == 2 ? 'btn-primary btn-md' : 'btn-md'}>All</ToggleButton>
                                        <ToggleButton value={OrganType.Kidney} onChange={() => this.changeOrganType(OrganType.Kidney)}
                                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Kidney) ? 'btn-primary btn-md' : 'btn-md'}>Kidney</ToggleButton>
                                        <ToggleButton value={OrganType.Liver} onChange={() => this.changeOrganType(OrganType.Liver)}
                                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Liver) ? 'btn-primary btn-md' : 'btn-md'}>Liver</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                            <Button bsStyle='success' onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>
                </FilterWrapper>
                <GridInvoiceCollections
                    data={data}
                    onGridReady={this.onGridReady}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getCollections: (isPaid, organType, paidStartDate, paidEndDate) => { return dispatch(ActionsAdminInvoice.getCollections(isPaid, organType, paidStartDate, paidEndDate)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Collections);